module.exports = __webpack_public_path__ + "static/moja_prica-12ecc2ef7f815fcdeeb5f0941828fe7c.png";